export default "__VITE_ASSET__338f7fb3__"